// extracted by mini-css-extract-plugin
export const inspiringQuote = "inspiring-quote-module--inspiringQuote--H3OXM";
export const imgContainer = "inspiring-quote-module--imgContainer--32_Fw";